const DownloadIcon = () => (
  <path
    clipRule="evenodd"
    d="M10.058 2.78558C10.058 2.35171 10.4097 2 10.8436 2H12.8109C13.2447 2 13.5964 2.35171 13.5964 2.78558V11.7308H15.672C16.3536 11.7308 16.7118 12.5394 16.2538 13.0442L12.4092 17.2818C12.0974 17.6254 11.5573 17.6254 11.2456 17.2818L7.40098 13.0442C6.94298 12.5394 7.30117 11.7308 7.98279 11.7308H10.058V2.78558ZM2.78558 20C2.35171 20 2 20.3517 2 20.7856V21.2144C2 21.6483 2.35171 22 2.78557 22H20.5476C20.9815 22 21.3332 21.6483 21.3332 21.2144V20.7856C21.3332 20.3517 20.9815 20 20.5477 20H2.78558Z"
    fill="#62686B"
  />
);

export default DownloadIcon;
